import classes from 'components/generics/flows/LoginSignUpFlow/index.module.scss';
import LoginSignupConfirmButton from 'components/generics/flows/LoginSignUpFlow/SharedComponents/LoginSignupConfirmButton';
import LoginSignUpHeader from 'components/generics/flows/LoginSignUpFlow/SharedComponents/LoginSignupHeader';
import SignUpForm from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp/components/SignUpForm';
import SignUpTerms from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp/components/SignUpTerms';
import useSignupConfirm from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp/useSignupConfirm';
import { useSignUp } from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/context';
import { useOnKeyPress } from 'hooks/logics/useOnKeyPress';
import React from 'react';

const ERROR_MESSAGE =
  "Looks like you're already with us. Try logging in instead of creating a new account.";

type Props = {
  onLogin: () => void;
  onFinish: () => void;
  tenant: boolean;
};

const SignUp = ({ onFinish, onLogin, tenant }: Props) => {
  const { isFormValid } = useSignUp();
  const { onConfirm, loading, detailsExist } = useSignupConfirm(
    onFinish,
    tenant
  );

  useOnKeyPress(() => {
    isFormValid && onConfirm();
  });

  return (
    <div className={classes.container}>
      <LoginSignUpHeader
        className={classes.header}
        title={'Create your account'}
        subtitleQuestion={'Already have an account?'}
        subtitleAnswer={'Log In'}
        onSwitchMethod={onLogin}
      />
      <SignUpForm className={classes.form} />
      <SignUpTerms className={classes.terms} />
      <LoginSignupConfirmButton
        loading={loading}
        hasError={detailsExist}
        errorMessage={ERROR_MESSAGE}
        onClick={onConfirm}
        text={'Create Account'}
        disabled={!isFormValid}
      />
    </div>
  );
};

export default SignUp;
